import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Stop = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19.762 30H12.237C11.174 30 10.162 29.587 9.412 28.825L3.175 22.587C2.425 21.837 2 20.825 2 19.762V12.237C2 11.174 2.412 10.162 3.175 9.412L9.412 3.175C10.162 2.425 11.174 2 12.237 2H19.749C20.812 2 21.824 2.412 22.574 3.175L28.812 9.412C29.562 10.162 29.987 11.174 29.987 12.237V19.749C29.987 20.812 29.574 21.824 28.812 22.574L22.574 28.812C21.824 29.587 20.824 30 19.761 30H19.762ZM12.238 4C11.701 4 11.201 4.213 10.826 4.588L4.589 10.825C4.214 11.2 4.001 11.7 4.001 12.237V19.75C4.001 20.288 4.214 20.788 4.589 21.163L10.826 27.401C11.201 27.776 11.701 27.988 12.238 27.988H19.75C20.288 27.988 20.788 27.776 21.163 27.401L27.401 21.163C27.776 20.788 27.988 20.288 27.988 19.75V12.238C27.988 11.701 27.776 11.201 27.401 10.826L21.163 4.589C20.788 4.214 20.288 4.001 19.75 4.001H12.238V4Z" />
		<path d="M21 20H11C9.35 20 8 18.65 8 17V15C8 13.35 9.35 12 11 12H21C22.65 12 24 13.35 24 15V17C24 18.65 22.65 20 21 20ZM11 14C10.45 14 10 14.45 10 15V17C10 17.55 10.45 18 11 18H21C21.55 18 22 17.55 22 17V15C22 14.45 21.55 14 21 14H11Z" />
	</svg>
);

export default Stop;
